module.exports = __webpack_public_path__ + "static/media/building.d4538893.svg";